module.exports = __webpack_public_path__ + "static/media/1.7af233ea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/Tutorial/screenshots/Managing/1.jpg
// module id = 1635
// module chunks = 0